// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import ElementUI from 'element-ui';

import 'element-ui/lib/theme-chalk/index.css';
import Steps from './components/steps.vue'
import eventBus from './util/eventBus'
Vue.use(ElementUI);
/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */


(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init', this.model.style, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {
    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      new Vue({
        el: dom,
        template: '<Steps :invoke="invoke" :model="model" :getLangMsg="getLangMsg" :headListDB="headList" :rowListDB="rowList" :index="index" :selectionList="selectionList" />',
        components: {
          Steps
        },
        data: {
          // scheduleData: data,
          rowList:[],
          headList:[],
          model: model,
          selectionList:[],
          index:0
        },
        mounted() {
          const self = this
          this.updateSub = eventBus.sub(model, 'update', (props) => {
            console.log('props',props)
            const { data } = props 
            //接收数据
            if(data.type=='init_data'){  
              //初始化列表
              self.rowList=data.row
              self.headList=data.head
            }
            if(data.type=='save_data'){
              // 当选项需要下拉框选项时，要返回下标的下拉框列表
              if(data.featuresType=='SELECT'){ 
                 self.selectionList=data.selectionList
                 self.index=data.index
              }
            }
            // if(data.type=='add_data'){  
            //   //新增
            // }
            // if(data.type=='delete_data'){  
            //   //新增
            // }
           
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('dynamicfield', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
